export default {
    title: 'Восстановление пароля',
    form: {
        fields: {
            phone: {
                label: 'Телефон',
                validations: {
                    require: 'Поле обязательно для заполнения',
                },
            },
            password: {
                label: 'Новый пароль',
                validations: {
                    require: 'Поле обязательно для заполнения',
                    repeat: 'Пароли должны совпадать',
                },
            },
            repeatPassword: {
                label: 'Повторите новый пароль',
                validations: {
                    require: 'Поле обязательно для заполнения',
                    repeat: 'Пароли должны совпадать',
                },
            },
        },
        submitButton: 'Войти',
    },
    labels: {
        phoneStep:
            'Введите номер телефона. Мы покажем номер, на который нужно позвонить для подтверждения и восстановления пароля.',
        callbackVerificationStep: 'Подтвердите номер телефона обратным звонком',
        callToInfo:
            'Пожалуйста, позвоните с номера {{login}} на номер {{callTo}}. После звонка нажмите «Я позвонил».',
        createPasswordStep: 'Отлично :) Теперь введите новый пароль',
    },
    buttons: {
        sendCode: 'Получить номер для звонка',
        createPassword: 'Сменить пароль',
        repeatVerification: 'Получить номер снова',
        confirmCall: 'Я позвонил',
    },
    messages: {
        successResetPassword: `Пароль успешно изменён`,
        requestCallbackAgain: `Номер для звонка обновлён для {{phoneNumber}}`,
        callbackVerificationFailed:
            'Не удалось подтвердить звонок. Вернитесь на предыдущий шаг и запросите номер снова.',
    },
};
